export default __webpack_public_path__ + "static/media/navArrow.476d095a.svg";